<template>
  <span>
    <span v-if="type">
      <button @click="$emit(action)" type="button" class="w3-button w3-text-theme">
        <font-awesome-icon :icon="[type, icon]" />  <span :style="nameStyle"> {{name}}</span><span v-if="numReactions"> ({{numReactions}})</span>
      </button> 
    </span>
    <span v-else>
      <button v-if="!isReacted" @click="$emit('toggleOn')" type="button" class="w3-button w3-text-theme"><i :class="'far '+icon"></i>  {{name}}<span v-if="numReactions"> ({{numReactions}})</span></button> 
      <button v-else @click="$emit('toggleOff')" type="button" class="w3-button w3-text-theme"><i :class="'fa '+icon"></i>  <b> {{name}}</b><span v-if="numReactions"> ({{numReactions}})</span></button> 
    </span>
  </span>
</template>

<script>
  import ReactButton from "./ReactButton.ts";

  export default ReactButton;
</script>
